import React from 'react'
import BudgetHistory from 'src/app/BudgetHistory/BudgetHistory'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { budgetHistoryRouteProps } from 'src/navigation/routeProps'

const BudgetHistoryAppRoute: AppRoute = {
  id: AppLocation.BudgetHistory,
  routeProps: budgetHistoryRouteProps,
  component: <BudgetHistory />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default BudgetHistoryAppRoute
